import { Moment } from "moment";

export const turnDate = (parmDate: Moment): string => {
    if (!parmDate) return "empty"

    const date = parmDate.toDate()

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
}    